<template>

   <table id="slots_list" >
      <tr class="table-row top">
         <td class="header order" style="width:7%;">Order</td>
         <td class="header asset" :style="isScoreboardVert ? 'width:29%;' : 'width:34%;'">Asset</td> 
         <td class="header duration" :style="isScoreboardVert ? 'width:7%;' : 'width:12%;'">Duration</td>
         <td class="header asset-type" style="width:9%;">Asset Type</td>
         <td class="header file-type" style="width:9%;">File Type</td>
         <td class="header status" style="width:12%;">Status</td>
         <td v-if="isScoreboardVert" class="header check loop" style="width:5%;">Loop</td>
         <td v-if="isScoreboardVert" class="header check hot-pick" style="width:5%;">Hot Pick</td>
         <td v-if="isScoreboardVert" class="header check no-ads" style="width:5%;">No Ads</td>
         <td class="header buttons" style="width:17%;"></td>
      </tr>

      <div class="row-wrapper" v-bar>  
         <div class="rows">
            <tbody>
               <program-block-slot-row 
                  v-for="(slot, index) in orderedSlots"
                  :key="slot.recid"
                  :slotObject="slot"
                  :assetRecid="slot.assetRecid"
                  :addRow="slot.recid == -1"
                  :isTrigger="isTrigger"
                  :showMP="showMP"
                  :active="slot.c_order == activeOrder && showMP"
                  :isFeed="isFeed"
                  :isGameBlock="isGameBlock"
                  :saveMe="saveMe"
                  :atEnd="slot.c_order == slots.length"
                  :recid="recid"
               ></program-block-slot-row >
            </tbody>
         </div>
      </div>
   </table>
</template>

<script>
// import BaseSlotList from './../../block_detail/BaseSlotList';
import BlockSlotList from '@/global/detail_display/BlockSlotList';

import ProgramBlockSlotRow from './ProgramBlockSlotRow';

import { mapActions, mapState } from 'vuex';

export default {
   extends: BlockSlotList,

   props: [
      // 'slots',
      'isTrigger',
      'showMP',
      'activeOrder',
      'isFeed',
      'isGameBlock',
      'saveMe',
      'recid'
   ],

   // mounted() {
   //    let self = this;
   //    this.$nextTick(() => {
   //      $('tbody').sortable({
   //         update: function() {
	// 				self.reorderSlots();
	// 		   }
   //       });
   //    });
   // },

   computed: {
      ...mapState('global', [
         'verticalId'
      ]),

      ...mapState('program_block', [
         'slots'
      ]),

      orderedSlots() {
         let sorted = [];
         let i = 1;
         let slotList = Object.values(this.slots);
         while (i <= slotList.length) {
            let slot = slotList.filter((s) => {
               return s.order == i;
            });
            sorted[i-1] = slot[0];
            i++;
         }
         return sorted;
      },

      isScoreboardVert() {
         return this.verticalId == 200;
      }
   },

   methods: {
      ...mapActions('program_block', [
         'changeSlotOrder'
      ])
   },

   components: {
      ProgramBlockSlotRow
   }
}
</script>

<style lang="scss" scoped>

#slots_list {
   width: 100%;
   margin-top: 1em;
   margin-bottom: 1em;
   font-size: .85em;

   width: calc(100% + 18px) !important; //hides the default scroll

   .table-row {
      padding-right: 25px;

      &.top {
         border-bottom: 1px solid #354658;
      }
   }

   
}

.row-wrapper {
   .rows {
      max-height: 500px;
      padding-right: 25px;
      width: 100% !important;
      
   }
}

.rows::-webkit-scrollbar {
  display: none;
}

.table-row {
   display: flex;
   justify-content: space-between;

   // &:first-child {
   //    border-bottom: 1px solid #313d4f;
   // }

   .header {
      font-size: 13px;
      font-weight: normal;
      color: #7f8fa4;
      text-align: left;

      padding-bottom: 10px;
   }

   .order {
      width: 6%;
      padding: 0 10px;
   } 

   .asset {
      width: 30%;
   }

   .duration {
      width: 9%;
   }

   .asset-type {
      width: 9%;
      text-align: center;
   }

   .file-type {
      width: 8%;
      text-align: center;
   } 

   .status {
      width: 10%;
      text-align: center;
   }

   // .check {
   //    // width: 53px;
   //    width: 65px;
   //    text-align: center;
   // }

   // .loop {
   //    order: 6;
   // }

   // .hot-pick {
   //    order: 7;
   // }

   // .no-ads {
   //    order: 8;
   // }

   .buttons {
      width: 18%;
   }
}
</style>



